import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const MiniCartAddedItems = () => {
  const orderRows = useSelector((state) => state.cart.orderRows);
  const addedProducts = useSelector((state) => state.cart.addedProducts);
  const productsToShow = (addedProducts || [])
    .map(pid => orderRows.find(r =>
      r.articleNumber === pid))
    .filter(Boolean);

  useEffect(() => {
    let anchor = document.querySelector('.anchor-mini-cart');
    
    if(anchor) {
      anchor.dataset.count = orderRows.length.toString();
    }
  }, [orderRows]);

  return (
      <ul className="mini-cart-menu__list">
        {productsToShow.map((p) => (
          <li key={p.articleNumber}>
            <img src={p.image} />
            <span>{p.name}</span>
          </li>
        ))}
      </ul>
  );
};

export default MiniCartAddedItems;
